export type AuthState = {
  user: any;
  name: string;
  idToken: string;
  accessToken: string;
  refreshToken: string;
  exp?: number;
  groups: Array<string>;
};

export const state: AuthState = {
  user: null,
  name: "",
  idToken: "",
  accessToken: "",
  refreshToken: "",
  exp: 0,
  groups: [],
};
